const subjects = [
  { label: 'Number', subjectId: 32 },
  { label: 'Data & Statistics', subjectId: 101 },
  { label: 'Geometry', subjectId: 71 },
  { label: 'Algebra', subjectId: 49 }
];

export default subjects;
